// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"caret-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0001 16.5L19 9.5L5 9.5L12.0001 16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0001 16.5L19 9.5L5 9.5L12.0001 16.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CaretDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-down',
    ref,
    icon: element,
  },
));

CaretDownIcon.displayName = 'CaretDownIcon';

export default CaretDownIcon;
